export enum FIND_TRIP_BY {
  CONFIRMATION_NO = 'confirmationNo',
  CREDITCARD_NO = 'creditCardNo',
  TICKET_NO = 'eTicketNo'
}

export enum FORM_TARGET {
  self = '_self',
  blank = '_blank'
}

export enum HTTP_HEADERS {
  TRANSACTION_ID_PREFIX = 'my-trips',
  APP_ID = 'WEB',
  CONTENT_TYPE = 'application/json; charset=UTF-8',
  MY_TRIP = 'MyTrip',
  CHANNEL_ID = 'DCOM',
  GUEST = 'GUEST',
  PURCHASE_PATH = 'MYTRIPS'
}

export enum MyTripEndpointKeys {
  FIND_PNR = 'FIND_PNR',
  FIND_PNR_LIST = 'FIND_PNR_LIST',
  PAYMENT_V2 = 'PAYMENT_V2',
  PAYMENT_AWS = 'PAYMENT_AWS',
  TRIPS_AEM_AUTH_CONFIG = 'TRIPS_AEM_AUTH_CONFIG',
  APP_TRIPS_UPCOMING_TRIP_URL = 'APP_TRIPS_UPCOMING_TRIP_URL',
  CHECK_IN_ACTION = 'CHECK_IN_ACTION',
  CHECK_IN_AWS_URL = 'CHECK_IN_AWS_URL',
  MY_TRIPS_STATIC = 'MY_TRIPS_STATIC',
  TRAVEL_RESERVATION = 'TRAVEL_RESERVATION'
}

export enum MOST_UPCOMING_TRIP {
  SKY_MILE_NUMBER = '${skymilesNbr}',
  NO_OF_TRIPS = '${nmbrOfTrips}',
  TRANSACTION_ID = '${transactionId}'
}

export enum IDP_APP {
  MY_TRIPS = 'MY_TRIPS'
}

export const MY_TRIPS_IDP_APP = 'MY_TRIPS';
export const SEARCH_TYPE_CONTROL = 'searchType';
export const APP_NAME = 'WEB';
export const TIMEOUT = 'TIMEOUT';
export const UPC_SYS_ERR = 'UPC_SYS_ERR';
export const BEARER = 'Bearer';
export const MY_TRIPS_LOADER_CONTENT = 'Loading...';
export const HEADER = 'HEADER';
